<div class="clouds-content" style="text-align:center">
    <h2 class="title">You are Idle</h2>
    <div class="container">
        <p class="text">You have been idle for {{idleTimeout}} minutes, if you wish to re authenticate please click the button below.</p>
        <p class="text">{{errorMessage}}</p>

        <button class="btn error" (click)="reAuthenticate()">Re Authenticate</button>
    </div>
</div>

